import { Injectable } from '@angular/core';

@Injectable()
export class unitSearchService {
  constructor() { }

  getUpdatedUnitSearch(txtUnitSearch: string): string {
    const unitTypes = ['HYD', 'G2S', 'G2O', 'G3C', 'MOD'];
    const hasDash = txtUnitSearch.indexOf('-') > -1;
    const matchesType = unitTypes.some(t => txtUnitSearch.toUpperCase().indexOf(t) > -1);

    if (hasDash && matchesType) {
      let updatedUnit = txtUnitSearch.split('-')[1].trim().substring(0, 6).trim().toUpperCase();
      if (updatedUnit.startsWith('N')) {
        updatedUnit = 'U' + updatedUnit.substring(1, 6).trim().toUpperCase();
      }
      return updatedUnit;
    }

    return txtUnitSearch;
  }
}
